import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  DateField,
  BooleanField,
  ChipField,
  ReferenceField,
  TopToolbar,
  EditButton,
  DeleteButton,
} from 'react-admin';

const UserSubscriptionShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

export const UserSubscriptionShow = () => {
  return (
    <Show actions={<UserSubscriptionShowActions />} title="Подписка пользователя">
      <SimpleShowLayout>
        <ReferenceField 
          source="userId" 
          reference="users"
          label="Пользователь"
        >
          <TextField source="email" />
        </ReferenceField>
        
        <ReferenceField 
          source="subscriptionPlanId" 
          reference="subscriptionPlans"
          label="План подписки"
        >
          <TextField source="name" />
        </ReferenceField>
        
        <ChipField source="status" label="Статус" />
        <DateField source="startDate" label="Дата начала" showTime />
        <DateField source="endDate" label="Дата окончания" showTime />
        <DateField source="cancelledAt" label="Дата отмены" showTime />
        <DateField source="renewedAt" label="Дата продления" showTime />
        
        <NumberField 
          source="amountPaid" 
          label="Сумма оплаты" 
          options={{ style: 'currency', currency: 'USD' }}
        />
        <TextField source="currency" label="Валюта" />
        <TextField source="paymentTransactionId" label="ID транзакции" />
        <BooleanField source="autoRenew" label="Автопродление" />
        
        <DateField source="createdAt" label="Создана" showTime />
        <DateField source="updatedAt" label="Обновлена" showTime />
      </SimpleShowLayout>
    </Show>
  );
};
